import styled from "styled-components"
import { Flex, scale, colors } from "@capioweb/ui-components/src"

export const CapioSharedLoginFormStyled = styled.form`
	max-width: ${scale.px(552 / 8)};
	margin: 0 auto;
	background-color: ${colors.white};
	border-radius: ${scale.px(3)};
`
export const CapioSharedLoginFormWideStyled = styled.form`
	max-width: ${scale.px(744 / 8)};
	margin: 0 auto;
	background-color: ${colors.white};
	border-radius: ${scale.px(3)};
`

export const CapioSharedLoginFormFooterStyled = styled(Flex)`
	border-top: 1px solid ${colors.greyEE};
`
